// extracted by mini-css-extract-plugin
module.exports = {"col":"styles-module__col___2OVoP","custom-card":"styles-module__custom-card___3H-mn","tile":"styles-module__tile___2qWG-","margin":"styles-module__margin___3gANW"};